function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { Col, Form, InputGroup } from "react-bootstrap";
import LockButton from "../../buttons/LockButton";
import React from "react"; // Temporary fix until react-bootstrap is upgraded to >=2.0.0,
// which has Form.Select

function CustomSelect({
  isInvalid,
  className = '',
  ...props
}) {
  className = className === '' ? 'custom-select' : `${className} custom-select`;

  if (isInvalid) {
    className = className + ' is-invalid';
  }

  return /*#__PURE__*/React.createElement("select", _extends({
    className: className
  }, props));
}

export function ConstantInterpretation({
  structure,
  setConstantValue,
  structureObject,
  teacherMode,
  lockConstantValue
}) {
  return /*#__PURE__*/React.createElement(Col, {
    lg: 12
  }, /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Form.Label, null, "Interpretation of individual constants"), Object.keys(structure.constants).map(constant => /*#__PURE__*/React.createElement(Form.Group, {
    key: constant
  }, /*#__PURE__*/React.createElement(InputGroup, {
    size: "sm",
    className: "has-validation"
  }, /*#__PURE__*/React.createElement(InputGroup.Prepend, null, /*#__PURE__*/React.createElement(InputGroup.Text, {
    id: 'constant-' + constant
  }, /*#__PURE__*/React.createElement("var", null, "i"), "(", constant, ") = ")), /*#__PURE__*/React.createElement(CustomSelect, {
    value: structure.constants[constant].value,
    id: 'constant-' + constant,
    onChange: e => setConstantValue(e.target.value, constant),
    disabled: structure.constants[constant].locked,
    isInvalid: structure.constants[constant].errorMessage.length > 0
  }, /*#__PURE__*/React.createElement("option", {
    key: '',
    value: ''
  }, "Select a\xA0domain element\u2026"), [...structureObject.domain].map(item => /*#__PURE__*/React.createElement("option", {
    key: item,
    value: item
  }, item))), teacherMode ? /*#__PURE__*/React.createElement(InputGroup.Append, null, /*#__PURE__*/React.createElement(LockButton, {
    lockFn: () => lockConstantValue(constant),
    locked: structure.constants[constant].locked
  })) : null, /*#__PURE__*/React.createElement(Form.Control.Feedback, {
    type: "invalid"
  }, structure.constants[constant].errorMessage))))));
}